// eslint-disable-next-line import/no-named-as-default
import Multiselect from "vue-multiselect";
import Vue from "vue";

Vue.component("MultiselectList", Multiselect);
